import type { State } from '../types';
import { apiUrl, log } from './common';

export async function syncDeleteRemote(
  id: string,
  retry: boolean,
  state: State,
  ensureAccessToken: (retry?: boolean) => Promise<string | null>,
  DEBUG: boolean
): Promise<void> {
  let token: string | null;
  try {
    token = await ensureAccessToken(Boolean(retry));
  } catch {
    throw new Error('Unable to acquire access token.');
  }
  if (!token) throw new Error('Unable to acquire access token.');
  const endpoint = apiUrl('extensions/scrapes/' + encodeURIComponent(id));
  if (DEBUG) log.debug('PATCH', endpoint, { deleted: true });
  const response = await fetch(endpoint, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
    body: JSON.stringify({ deleted: true }),
  });
  if (DEBUG) log.debug('PATCH status', response.status, 'ct', response.headers.get('content-type'));
  if (response.status === 401 && !retry) {
    (state as any).extAccessToken = null;
    return syncDeleteRemote(id, true, state, ensureAccessToken, DEBUG);
  }
  if (!response.ok) {
    const text = await response.text().catch(() => '');
    throw new Error(text || 'Failed to delete lot (' + response.status + ')');
  }
}
